/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($, _c, undefined) {
    'use strict';

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.

    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                // disable the page loader
                if (!_c.support.transition || !_c.support.transition.end) {
                    _c.showLoading = false;
                }

                (function () {
					$(document).ready(function(){
						setTimeout(function(){
							$('.home-hero h1').css({'opacity': '1', 'right': '0'});
							$('.expertise-hero h1').css({'opacity': '1', 'right': '0'});
							$('.about-hero h1').css({'opacity': '1', 'right': '0'});
							$('.about-hero .name').addClass('on');
							$('.bio-hero h1').css({'opacity': '1', 'right': '0'});
							$('.content .pvc_stats').css('display', "none");
						}, 500);
					});
                    $(window).load(function () {
                        $(document).ajaxStart(function() {
                            $('body').append('<div class="loader"><div class="spinner"></div></div>');
                        });
                        $(document).ajaxStop(function() {
                            $('body > .loader').remove();
                        });
                    });
                })();

                (function () {
                    /* $('.hamburger').on('click', function (e) {
                        e.preventDefault();
                        if ($(this).hasClass('is-active')) {
                            $('.topnav').slideDown(600);
                            $(this).next().hide();
                        } else {
                            $('.topnav').slideUp(600);
                            $(this).next().show();
                        }
                    }); */
                })();

                (function () {
                    $('.form-checkbox label').on('change', function () {
                        if ($(this).prev().hasClass('checked')) {
                            $('input[type="checkbox"]').prop('checked', false);
                            $('input[type="checkbox"]').removeClass('checked');
                        } else {
                            $('input[type="checkbox"]').prop('checked', true);
                            $('input[type="checkbox"]').addClass('checked');
                        }
                    });
                    $('form input, form textarea').on('focus', function () {
                        $(this).prev().css('opacity', '1');
                    });
                    $('form input, form textarea').on('blur', function () {
                        $(this).prev().css('opacity', '0');
                    });
                })();

                (function () {
                    $('#menu-item-233 a').addClass('contact-btn');
                    $('.contact-btn').on('click', function (e) {
                        e.preventDefault();
                        $('#contact-form').slideDown(600);
                        $('.main').css('opacity', '0');
                        $('html, body').animate({
                            scrollTop: $('.header').offset().top
                        }, 1000);
                    });
                    $('.topnav .contact-btn').on('click', function (e) {
                        e.preventDefault();
                        $('.hamburger').removeClass('is-active');
                        $('.topnav').slideUp(600);
                        $('.main').css('opacity', '1');
                        $('.header .contact-btn').show();
                    });
                    $('#contact-form .close').on('click', function (e) {
                        e.preventDefault();
                        $('#contact-form').slideUp(600);
                        $('.main').css('opacity', '1');
                    });
                })();

                (function () {
                    $('.news-button').on('click', function (e) {
                        e.preventDefault();
                        if ($(this).hasClass('open')) {
                            $(this).removeClass('open');
                            $('#newsletter-form').slideUp(600);
                        } else {
                            $(this).addClass('open');
                            $('#newsletter-form').slideDown(600);
                        }
                    });
                })();

                /* (function () {
                    $('.more').on('click', function (e) {
                        e.preventDefault();
                        if (!$(this).hasClass('open')) {
                            $(this).addClass('open');
                            $(this).prev().css('max-height', '100%');
                            $(this).text('Show Less');
                        } else {
                            $(this).removeClass('open');
                            $(this).prev().css('max-height', '140px');
                            $(this).text('Show More');
                        }
                    });
                })(); */

                (function () {
                    if ($('body').hasClass('about')) {
                        var video = document.getElementById("about-video");
                        $('.play-video').on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $('#lightbox').fadeIn(600);
                            $('.main, .header').css('opacity', '0');
                            video.play();
                        });
                        $('html').on('click', function (e) {
                            $('#lightbox').fadeOut(600);
                            $('.main, .header').css('opacity', '1');
                            video.pause();
                            video.currentTime = 0;
                        });
                    }
                })();


                (function () {
                    /* if ($('body').hasClass('home')) {
                        var video = document.getElementById("home-video");
                        $('.play-video').on('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $('#lightbox').fadeIn(600);
                            $('.main, .header').css('opacity', '0');
                            video.play();
                        });
                        $('html').on('click', function (e) {
                            $('#lightbox').fadeOut(600);
                            $('.main, .header').css('opacity', '1');
                            video.pause();
                            video.currentTime = 0;
                        });
                    } */
                })();

                (function () {
                    $('.scrollto').on('click', function (e) {
                        e.preventDefault();
                        var section = $(this).attr('href');
                        $('html, body').animate({
                            scrollTop: $(section).offset().top
                        }, 1000);
                    });
                })();

                (function () {
                    $('.topscroll').on('click', function (e) {
                        console.log("hey");
                        e.preventDefault();
                        var section = $(this).attr('href');
                        $('html, body').animate({
                            scrollTop: $(section).offset().top
                        }, 8000);
                    });
                })();


                (function () {
                    $('.filter-dd a').on('click', function (e) {
                        e.preventDefault();
                        if ($(this).parent().hasClass('open')) {
                            $(this).parent().removeClass('open');
                            $('.filter-box').slideUp(600);
                        } else {
                            $(this).parent().addClass('open');
                            $('.filter-box').slideDown(600);
                        }
                    });
                })();

                (function () {

                    function home_signpost() {

                        $(window).on('scroll', function () {

                            var scrollTop = $(window).scrollTop();
                            var window_height_half = $(window).height() / 2;

                            var section1_areaTop = $('#section1').offset().top;
                            var section1_areaTop_half = section1_areaTop - window_height_half;
                            var section1_areaTop_height = $('#section1').height();
                            var section1_areaTop_sign = section1_areaTop + section1_areaTop_height;
                            var section1_areaTop_sign_half = section1_areaTop_sign - section1_areaTop_half;

                            if (scrollTop > section1_areaTop_half && scrollTop < (section1_areaTop_sign_half)) {
                                $('.sign-posting .section1').addClass('active');
                            } else {
                                $('.sign-posting .section1').removeClass('active');
                            }

                            var section2_areaTop = $('#section2').offset().top;
                            var section2_areaTop_half = section2_areaTop - window_height_half;
                            var section2_areaTop_height = $('#section2').height();
                            var section2_areaTop_sign = section2_areaTop + section2_areaTop_height;
                            var section2_areaTop_sign_half = section2_areaTop_sign - section2_areaTop_half;

                            if (scrollTop > section2_areaTop_half && scrollTop < (section2_areaTop_sign_half + section2_areaTop_height)) {
                                $('.sign-posting .section2').addClass('active');
                            } else {
                                $('.sign-posting .section2').removeClass('active');
                            }

                            var section3_areaTop = $('#section3').offset().top;
                            var section3_areaTop_half = section3_areaTop - window_height_half;
                            var section3_areaTop_height = $('#section3').height();
                            var section3_areaTop_sign = section3_areaTop + section3_areaTop_height;
                            var section3_areaTop_sign_half = section3_areaTop_sign - section3_areaTop_half;

                            if (scrollTop > section3_areaTop_half && scrollTop < (section3_areaTop + section3_areaTop_height - window_height_half)) {
                                $('.sign-posting .section3').addClass('active');
                            } else {
                                $('.sign-posting .section3').removeClass('active');
                            }

                            var section4_areaTop = $('#section4').offset().top;
                            var section4_areaTop_half = section4_areaTop - window_height_half;
                            var section4_areaTop_height = $('#section4').height();
                            var section4_areaTop_sign = section4_areaTop + section4_areaTop_height;
                            var section4_areaTop_sign_half = section4_areaTop_sign - section4_areaTop_half;

                            if (scrollTop > section4_areaTop_half && scrollTop < (section4_areaTop + section4_areaTop_height - window_height_half)) {
                                $('.sign-posting .section4').addClass('active');
                            } else {
                                $('.sign-posting .section4').removeClass('active');
                            }

                            var section5_areaTop = $('#section5').offset().top;
                            var section5_areaTop_half = section5_areaTop - window_height_half;
                            var section5_areaTop_height = $('#section5').height();
                            var section5_areaTop_sign = section5_areaTop + section5_areaTop_height;
                            var section5_areaTop_sign_half = section5_areaTop_sign - section5_areaTop_half;

                            if (scrollTop > section5_areaTop_half && scrollTop < (section5_areaTop + section5_areaTop_height - window_height_half)) {
                                $('.sign-posting .section5').addClass('active');
                            } else {
                                $('.sign-posting .section5').removeClass('active');
                            }

                            var section6_areaTop = $('#section6').offset().top;
                            var section6_areaTop_half = section6_areaTop - window_height_half;
                            var section6_areaTop_height = $('#section6').height();
                            var section6_areaTop_sign = section6_areaTop + section6_areaTop_height;
                            var section6_areaTop_sign_half = section6_areaTop_sign - section6_areaTop_half;

                            if (scrollTop > section6_areaTop_half && scrollTop < (section6_areaTop + section6_areaTop_height - window_height_half)) {
                                $('.sign-posting .section6').addClass('active');
                            } else {
                                $('.sign-posting .section6').removeClass('active');
                            }

                        });
                    }

                    //if ($('body').hasClass('home')) {
                     //   home_signpost();
                    //}

                    function about_signpost() {

                        $(window).on('scroll', function () {

                            var scrollTop = $(window).scrollTop();
                            var window_height_half = $(window).height() / 2;
                            var section_footer = $('.footer').offset().top;

                            var section1_areaTop = $('#section1').offset().top;
                            var section1_areaTop_half = section1_areaTop - window_height_half;
                            var section1_areaTop_height = $('#section1').height();
                            var section1_areaTop_sign = section1_areaTop + section1_areaTop_height;
                            var section1_areaTop_sign_half = section1_areaTop_sign - section1_areaTop_half;

                            if (scrollTop > section1_areaTop_half && scrollTop < (section1_areaTop_sign_half)) {
                                $('.sign-posting .section1').addClass('active');
                            } else {
                                $('.sign-posting .section1').removeClass('active');
                            }

                            var section2_areaTop = $('#section2').offset().top;
                            var section2_areaTop_half = section2_areaTop - window_height_half;
                            var section2_areaTop_height = $('#section2').height();
                            var section2_areaTop_sign = section2_areaTop + section2_areaTop_height;
                            var section2_areaTop_sign_half = section2_areaTop_sign - section2_areaTop_half;

                            if (scrollTop > section2_areaTop_half && scrollTop < (section2_areaTop_sign_half + section2_areaTop_height)) {
                                $('.sign-posting .section2').addClass('active');
                            } else {
                                $('.sign-posting .section2').removeClass('active');
                            }

                            var section3_areaTop = $('#section3').offset().top;
                            var section3_areaTop_half = section3_areaTop - window_height_half;
                            var section3_areaTop_height = $('#section3').height();
                            var section3_areaTop_sign = section3_areaTop + section3_areaTop_height;
                            var section3_areaTop_sign_half = section3_areaTop_sign - section3_areaTop_half;

                            if (scrollTop > section3_areaTop_half && scrollTop < (section3_areaTop + section3_areaTop_height - window_height_half)) {
                                $('.sign-posting .section3').addClass('active');
                            } else {
                                $('.sign-posting .section3').removeClass('active');
                            }

                            var section4_areaTop = $('#section4').offset().top;
                            var section4_areaTop_half = section4_areaTop - window_height_half;
                            var section4_areaTop_height = $('#section4').height();
                            var section4_areaTop_sign = section4_areaTop + section4_areaTop_height;
                            var section4_areaTop_sign_half = section4_areaTop_sign - section4_areaTop_half;

                            if (scrollTop > section4_areaTop_half && scrollTop < (section_footer - window_height_half - 400)) {
                                $('.sign-posting .section4').addClass('active');
                            } else {
                                $('.sign-posting .section4').removeClass('active');
                            }

                        });
                    }

                    if ($('body').hasClass('about')) {
                        about_signpost();
                    }

                    function cases_signpost() {

                        $(window).on('scroll', function () {

                            var scrollTop = $(window).scrollTop();
                            var window_height_half = $(window).height() / 2;
                            var section_footer = $('.footer').offset().top;

                            var section1_areaTop = $('#section2').offset().top;
                            var section1_areaTop_half = section1_areaTop - window_height_half;
                            var section1_areaTop_height = $('#section2').height();
                            var section1_areaTop_sign = section1_areaTop + section1_areaTop_height;
                            var section1_areaTop_sign_half = section1_areaTop_sign - section1_areaTop_half;

                            if (scrollTop > section1_areaTop_half && scrollTop < (section_footer - window_height_half - 400)) {
                                $('.sign-posting .section1').addClass('active');
                            } else {
                                $('.sign-posting .section1').removeClass('active');
                            }

                        });
                    }

                    if ($('body').hasClass('cases')) {
                        cases_signpost();
                    }

                    function craft_signpost() {

                        $(window).on('scroll', function () {

                            var scrollTop = $(window).scrollTop();
                            var window_height_half = $(window).height() / 2;
                            var section_footer = $('.footer').offset().top;

                            var section1_areaTop = $('#section1').offset().top;
                            var section1_areaTop_half = section1_areaTop - window_height_half;
                            var section1_areaTop_height = $('#section1').height();
                            var section1_areaTop_sign = section1_areaTop + section1_areaTop_height;
                            var section1_areaTop_sign_half = section1_areaTop_sign - section1_areaTop_half;

                            if (scrollTop > section1_areaTop_half && scrollTop < (section1_areaTop_sign_half)) {
                                $('.sign-posting .section1').addClass('active');
                            } else {
                                $('.sign-posting .section1').removeClass('active');
                            }

                            var section2_areaTop = $('#section2').offset().top;
                            var section2_areaTop_half = section2_areaTop - window_height_half;
                            var section2_areaTop_height = $('#section2').height();
                            var section2_areaTop_sign = section2_areaTop + section2_areaTop_height;
                            var section2_areaTop_sign_half = section2_areaTop_sign - section2_areaTop_half;

                            console.log(scrollTop);
                            console.log(section2_areaTop_sign_half + section2_areaTop_height);

                            if (scrollTop > section2_areaTop_half && scrollTop < (section2_areaTop + section2_areaTop_height - window_height_half)) {
                                $('.sign-posting .section2').addClass('active');
                            } else {
                                $('.sign-posting .section2').removeClass('active');
                            }

                            var section3_areaTop = $('#section3').offset().top;
                            var section3_areaTop_half = section3_areaTop - window_height_half;
                            var section3_areaTop_height = $('#section3').height();
                            var section3_areaTop_sign = section3_areaTop + section3_areaTop_height;
                            var section3_areaTop_sign_half = section3_areaTop_sign - section3_areaTop_half;

                            if (scrollTop > section3_areaTop_half && scrollTop < (section3_areaTop + section3_areaTop_height - window_height_half)) {
                                $('.sign-posting .section3').addClass('active');
                            } else {
                                $('.sign-posting .section3').removeClass('active');
                            }

                            var section4_areaTop = $('#section4').offset().top;
                            var section4_areaTop_half = section4_areaTop - window_height_half;
                            var section4_areaTop_height = $('#section4').height();
                            var section4_areaTop_sign = section4_areaTop + section4_areaTop_height;
                            var section4_areaTop_sign_half = section4_areaTop_sign - section4_areaTop_half;

                            if (scrollTop > section4_areaTop_half && scrollTop < (section_footer - window_height_half - 400)) {
                                $('.sign-posting .section4').addClass('active');
                            } else {
                                $('.sign-posting .section4').removeClass('active');
                            }

                        });
                    }

                    if ($('body').hasClass('our-craft')) {
                        craft_signpost();
                    }

                    function blog_signpost() {

                        $(window).on('scroll', function () {

                            var scrollTop = $(window).scrollTop();
                            var window_height_half = $(window).height() / 2;
                            var section_footer = $('.footer').offset().top;

                            var section1_areaTop = $('#section1').offset().top;
                            var section1_areaTop_half = section1_areaTop - window_height_half;
                            var section1_areaTop_height = $('#section1').height();
                            var section1_areaTop_sign = section1_areaTop + section1_areaTop_height;
                            var section1_areaTop_sign_half = section1_areaTop_sign - section1_areaTop_half;

                            if (scrollTop > section1_areaTop_half && scrollTop < (section_footer - window_height_half - 400)) {
                                $('.sign-posting .section1').addClass('active');
                            } else {
                                $('.sign-posting .section1').removeClass('active');
                            }

                        });
                    }

                    if ($('body').hasClass('home')) {
                        blog_signpost();
                    }

                    function specialties_signpost() {

                        $(window).on('scroll', function () {

                            var scrollTop = $(window).scrollTop();
                            var window_height_half = $(window).height() / 2;

                            var section1_areaTop = $('#section1').offset().top;
                            var section1_areaTop_half = section1_areaTop - window_height_half;
                            var section1_areaTop_height = $('#section1').height();
                            var section1_areaTop_sign = section1_areaTop + section1_areaTop_height;
                            var section1_areaTop_sign_half = section1_areaTop_sign - section1_areaTop_half;

                            if (scrollTop > section1_areaTop_half && scrollTop < (section1_areaTop_height - window_height_half)) {
                                $('.sign-posting .section1').addClass('active');
                            } else {
                                $('.sign-posting .section1').removeClass('active');
                            }

                        });
                    }

                    if ($('body').hasClass('specialties')) {
                        specialties_signpost();
                    }
                })();

                (function () {
                    $(window).on('scroll', function () {

                        var scrollTop = $(window).scrollTop();
                        var window_height_half = $(window).height() / 2;

                        /* if ($('body').hasClass('home')) {
                            var about_areaTop = $('#section1').offset().top;
                            var about_areaTop_half = about_areaTop - window_height_half;
                            var about_areaTop_height = $('#section1').height();
                            var about_areaTop_sign = about_areaTop + about_areaTop_height;
                            var about_areaTop_sign_half = about_areaTop_sign - about_areaTop_half;
                            if (scrollTop > about_areaTop_half && scrollTop < (about_areaTop_sign_half)) {
                                $('.home-about p').addClass('on');
                                $('.home-about-photo').addClass('fadeInUp');
                            } else {
                                $('.home-about p').removeClass('on');
                            }

                            var expertise_areaTop = $('#section2').offset().top;
                            var expertise_areaTop_half = expertise_areaTop - window_height_half;
                            var expertise_areaTop_height = $('#section2').height();
                            var expertise_areaTop_sign = expertise_areaTop + expertise_areaTop_height;
                            var expertise_areaTop_sign_half = expertise_areaTop_sign - expertise_areaTop_half;
                            if (scrollTop > expertise_areaTop_half && scrollTop < (expertise_areaTop_sign - window_height_half)) {
                                $('.home-expertise h3').addClass('on');
                                $('.expertise-item').addClass('fadeInUp');
                            } else {
                                $('.home-expertise h3').removeClass('on');
                            }

                            var cases_areaTop = $('#section3').offset().top;
                            var cases_areaTop_half = cases_areaTop - window_height_half;
                            var cases_areaTop_height = $('#section3').height();
                            var cases_areaTop_sign = cases_areaTop + cases_areaTop_height;
                            var cases_areaTop_sign_half = cases_areaTop_sign - cases_areaTop_half;
                            if (scrollTop > cases_areaTop_half && scrollTop < (cases_areaTop_sign - window_height_half)) {
                                $('.home-cases .case-item .date').addClass('on');
                                $('.case-item').addClass('fadeInUp');
                            } else {
                                $('.home-cases .case-item .date').removeClass('on');
                            }

                            var distinctions_areaTop = $('#section4').offset().top;
                            var distinctions_areaTop_half = distinctions_areaTop - window_height_half;
                            var distinctions_areaTop_height = $('#section4').height();
                            var distinctions_areaTop_sign = distinctions_areaTop + distinctions_areaTop_height;
                            var distinctions_areaTop_sign_half = distinctions_areaTop_sign - distinctions_areaTop_half;
                            if (scrollTop > distinctions_areaTop_half && scrollTop < (distinctions_areaTop_sign - window_height_half)) {
                                $('.home-distinctions .award-item').addClass('fadeInUp');
                            } else {

                            }

                            var testimonials_areaTop = $('#section5').offset().top;
                            var testimonials_areaTop_half = testimonials_areaTop - window_height_half;
                            var testimonials_areaTop_height = $('#section5').height();
                            var testimonials_areaTop_sign = testimonials_areaTop + testimonials_areaTop_height;
                            var testimonials_areaTop_sign_half = testimonials_areaTop_sign - testimonials_areaTop_half;
                            if (scrollTop > testimonials_areaTop_half && scrollTop < (testimonials_areaTop_sign - window_height_half)) {
                                $('.home-testimonials .name').addClass('on');
                                $('.home-testimonials .quote-item').addClass('fadeInUp');
                            } else {
                                $('.home-testimonials .name').removeClass('on');
                            }

                            var press_areaTop = $('#section6').offset().top;
                            var press_areaTop_half = press_areaTop - window_height_half;
                            var press_areaTop_height = $('#section6').height();
                            var press_areaTop_sign = press_areaTop + press_areaTop_height;
                            var press_areaTop_sign_half = press_areaTop_sign - press_areaTop_half;
                            if (scrollTop > press_areaTop_half && scrollTop < (press_areaTop_sign - window_height_half)) {
                                $('.home-press .date').addClass('on');
                                $('.home-press .col-md-6').addClass('fadeInUp');
                                // $('.home-press .featured-post .post').css('bottom', '0px');
                                // $('.home-press .featured-post .post').css('left', '0px');
                                //$('.home-press .featured-post').addClass('fadeInUp');
                            } else {
                                $('.home-press .date').removeClass('on');
                            }
                        } */

                        if ($('body').hasClass('our-craft')) {
                            var craft_areaTop = $('#section1').offset().top;
                            var craft_areaTop_half = craft_areaTop - window_height_half;
                            var craft_areaTop_height = $('#section1').height();
                            var craft_areaTop_sign = craft_areaTop + craft_areaTop_height;
                            var craft_areaTop_sign_half = craft_areaTop_sign - craft_areaTop_half;
                            if (scrollTop > craft_areaTop_half && scrollTop < (craft_areaTop_sign)) {
                                $('#section1 h2').addClass('on');
                                $('#section1 .craft-item').addClass('fadeInUp');
                            } else {
                                $('#section1 h2').removeClass('on');
                            }

                            var consulting_areaTop = $('#section2').offset().top;
                            var consulting_areaTop_half = consulting_areaTop - window_height_half;
                            var consulting_areaTop_height = $('#section2').height();
                            var consulting_areaTop_sign = consulting_areaTop + consulting_areaTop_height;
                            var consulting_areaTop_sign_half = consulting_areaTop_sign - consulting_areaTop_half;
                            if (scrollTop > consulting_areaTop_half && scrollTop < (consulting_areaTop_sign)) {
                                $('#section2 h2').addClass('on');
                                $('#section2 .craft-item').addClass('fadeInUp');
                            } else {
                                $('#section2 .craft h2').removeClass('on');
                            }

                            var litigation_areaTop = $('#section3').offset().top;
                            var litigation_areaTop_half = litigation_areaTop - window_height_half;
                            var litigation_areaTop_height = $('#section3').height();
                            var litigation_areaTop_sign = litigation_areaTop + litigation_areaTop_height;
                            var litigation_areaTop_sign_half = litigation_areaTop_sign - litigation_areaTop_half;
                            if (scrollTop > litigation_areaTop_half && scrollTop < (litigation_areaTop_sign - window_height_half)) {
                                $('#section3 h2').addClass('on');
                                $('#section3 .craft-item').addClass('fadeInUp');
                            } else {
                                $('#section3 h2').removeClass('on');
                            }

                            var trial_areaTop = $('#section4').offset().top;
                            var trial_areaTop_half = trial_areaTop - window_height_half;
                            var trial_areaTop_height = $('#section4').height();
                            var trial_areaTop_sign = trial_areaTop + trial_areaTop_height;
                            var trial_areaTop_sign_half = trial_areaTop_sign - trial_areaTop_half;
                            if (scrollTop > trial_areaTop_half && scrollTop < (trial_areaTop_sign - window_height_half)) {
                                $('#section4 h2').addClass('on');
                                $('#section4 .name').addClass('on');
                                $(' #section4 .craft-item').addClass('fadeInUp');
                            } else {
                                $('#section4 h2').removeClass('on');
                                $('#section4 .name').removeClass('on');
                            }
                        }

                        if ($('body').hasClass('about')) {
                            var about_page_areaTop = $('#section1').offset().top;
                            var about_page_areaTop_half = about_page_areaTop - window_height_half;
                            var about_page_areaTop_height = $('#section1').height();
                            var about_page_areaTop_sign = about_page_areaTop + about_page_areaTop_height;
                            var about_page_areaTop_sign_half = about_page_areaTop_sign - about_page_areaTop_half;
                            if (scrollTop > about_page_areaTop_half && scrollTop < (about_page_areaTop_sign - window_height_half)) {
                                $('.about .copy').addClass('on');
                                $('.about .about-photo').addClass('fadeInUp');
                            } else {
                                $('.about .copy').removeClass('on');
                            }

                            var team_areaTop = $('#section2').offset().top;
                            var team_areaTop_half = team_areaTop - window_height_half;
                            var team_areaTop_height = $('#section2').height();
                            var team_areaTop_sign = team_areaTop + team_areaTop_height;
                            var team_areaTop_sign_half = team_areaTop_sign - team_areaTop_half;
                            if (scrollTop > team_areaTop_half && scrollTop < (team_areaTop_sign - window_height_half)) {
                                $('.about-team .quote-name').addClass('on');
                                $('.team-member').addClass('fadeInUp');
                            } else {
                                $('.about-team .quote-name').removeClass('on');
                            }

                            var about_atlanta_areaTop = $('.atlanta').offset().top;
                            var about_atlanta_areaTop_half = about_atlanta_areaTop - window_height_half;
                            var about_atlanta_areaTop_height = $('.atlanta').height();
                            var about_atlanta_areaTop_sign = about_atlanta_areaTop + about_atlanta_areaTop_height;
                            var about_atlanta_areaTop_sign_half = about_atlanta_areaTop_sign - about_atlanta_areaTop_half;
                            if (scrollTop > about_atlanta_areaTop_half && scrollTop < (about_atlanta_areaTop_sign - window_height_half)) {
                                $('.atlanta p').addClass('on');
                            } else {
                                $('.atlanta p').removeClass('on');
                            }

                            var about_philadelphia_areaTop = $('.philadelphia').offset().top;
                            var about_philadelphia_areaTop_half = about_philadelphia_areaTop - window_height_half;
                            var about_philadelphia_areaTop_height = $('.philadelphia').height();
                            var about_philadelphia_areaTop_sign = about_philadelphia_areaTop + about_philadelphia_areaTop_height;
                            var about_philadelphia_areaTop_sign_half = about_philadelphia_areaTop_sign - about_philadelphia_areaTop_half;
                            if (scrollTop > about_philadelphia_areaTop_half && scrollTop < (about_philadelphia_areaTop_sign - window_height_half)) {
                                $('.philadelphia p').addClass('on');
                            } else {
                                $('.philadelphia p').removeClass('on');
                            }

                            var about_press_areaTop = $('#section4').offset().top;
                            var about_press_areaTop_half = about_press_areaTop - window_height_half;
                            var about_press_areaTop_height = $('#section4').height();
                            var about_press_areaTop_sign = about_press_areaTop + about_press_areaTop_height;
                            var about_press_areaTop_sign_half = about_press_areaTop_sign - about_press_areaTop_half;
                            if (scrollTop > about_press_areaTop_half && scrollTop < (about_press_areaTop_sign - window_height_half)) {
                                $('.post-item').addClass('fadeInUp');
                            } else {

                            }

                        }
                    });
                })();


            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },

        // Home page
        /* 'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        }, */

        // Testimonials page
        'testmonials': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
                // $('.load-more a.cta').click(function (event) {
                //     event.preventDefault();
                //     lloadTestimonials(true);
                // });

                // function loadTestimonials(isLoadingMore){
                //     if (!isLoadingMore) {
                //         $("#page_num").val(1);
                //     }
                //     else {
                //         $("#page_num").val(parseInt($("#page_num").val()) + 1);
                //     }

                //     var pageValue = $("#page_num").val();
                //     var url = $("#url").val();
                //     $.ajax({
                //         url: url,
                //         method: "POST",
                //         data: {page: pageValue},
                //         complete: function (response) {
                //             if (typeof response != "undefined") {

                //                 
                //             }
                //         }
                //     });
                // }
            }
        },

        // Cases page
        'cases': {
            init: function () {


                $('.load-more a.cta').click(function (event) {
                    event.preventDefault();
                    loadCases(true);
                });

                // When a specialty is selected, Ajax search for cases within that specialty
                $(".filter-dd li ul li a").click(function (event) {
                    event.preventDefault();
                    var filter = $(this).attr("data-slug");
                    $('#specialty').val(filter);

                    $('.filter-dd > li > a').html($(this).html() + '<span class="ico"></span>');

                    if ($('.filter-dd li').hasClass('open')) {
                        $('.filter-dd li').removeClass('open');
                        $('.filter-box').slideUp(600);
                    }

                    loadCases(false);
                });

                function loadCases(isLoadingMore) {

                    if (!isLoadingMore) {
                        $("#page_num").val(1);
                    }
                    else {
                        $("#page_num").val(parseInt($("#page_num").val()) + 1);
                    }

                    var specialty = $('#specialty').val();
                    var pageValue = $("#page_num").val();
                    var url = $("#url").val();

                    $.ajax({
                        url: url,
                        method: "POST",
                        data: {specialty: specialty, page: pageValue},
                        complete: function (response) {
                            if (typeof response != "undefined") {

                                if (response.responseJSON.items.length > 0) {

                                    if (!isLoadingMore) {
                                        $('.all.cases .container-fluid .row').not('.load-more').remove();
                                    }

                                    var totalPosts = response.responseJSON.found_posts;
                                    var displayedTotal = $("#page_num").val() * 6;
                                    var showNextPage = displayedTotal < totalPosts;

                                    if (showNextPage) {
                                        $(".load-more").show();
                                    } else {
                                        $(".load-more").hide();
                                    }

                                    for (var i = 0; i < response.responseJSON.items.length; i++) {
                                        var item = response.responseJSON.items[i];
                                        $('.all.cases .container-fluid .row.load-more').before('<div class="row"> <div class="col-md-3"> <h2 class="post-title">' + item.post_title + '</h2> </div> <div class="col-md-3"> <p class="term">' + item.term + '</p> </div> <div class="col-md-6">' + item.content + '</div> </div>');
                                    }

                                }
                                else {
                                    $('.all.cases .container-fluid .row').not('.load-more').remove();
                                    $(".all.cases .container-fluid").append('<div class="row empty-search"><h1>Please Try Another Search</h1></div>');
                                    $(".load-more").hide();
                                }
                            }
                        }
                    });
                }

                // JavaScript to be fired on the about us page
            }
        },

        'home': {
            init: function () {

                $('.search-box form').submit(function() {
                    loadBlog(false);

                    $('.filter-box li').removeClass('active');
                    $('.filter-box li:first-child').addClass('active');

                    $('html, body').animate({
                        scrollTop: $('.posts-list').offset().top
                    }, 2000);

                    return false;
                });

                $('.load-more a.cta').click(function (event) {
                    event.preventDefault();
                    loadBlog(true);
                });

                // When a tag is selected, Ajax search for blog posts with that tag
                $('.filter-box li a').click(function (event) {
                    event.preventDefault();

                    $('#search-input').val('');

                    if($(this).parent('li').index() == 0) {
                        $('.filter-box li').removeClass('active');
                        $(this).parent('li').addClass('active');
                        $('#tag').val('');
                    } else {
                        $('.filter-box li:first-child').removeClass('active');
                        $(this).parent('li').toggleClass('active');

                        var tags = [];
                        $('.filter-box li.active').each(function(i, el) {
                            tags.push($('a', el).attr('data-slug'));
                        });

                        $('#tag').val(tags.join(','));
                    }

                    if($('.filter-box li.active').length == 0) {
                        $('.filter-box li:first-child').addClass('active');
                        $('#tag').val('');
                    }

                    loadBlog(false);
                });

                $(document).ready(function() {
                    loadBlog(false);
                });

                $(document).scroll(function(e) {
                    e.preventDefault();
                    if($('.load-more').offset().top < ($(window).scrollTop() + $(window).height())) {
                        //if(!$('body').hasClass('loading') && !$('.load-more').hasClass('disabled')) {
                        //    $('body').addClass('loading');
                        //    loadBlog(true);
                        //}
                    }
                });

                function loadBlog(isLoadingMore)
                {

                    $('#page_num').val(isLoadingMore ? (parseInt($('#page_num').val()) + 1) : 1);

                    var tag = $('#tag').val(),
                        pageValue = $('#page_num').val(),
                        url = $('#url').val(),
                        searchValue = $('#search-input').val();

                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: {tag: tag, page: pageValue, search: searchValue},
                        complete: function(response) {
                            if(typeof response != 'undefined') {
                                if (response.responseJSON.items.length > 0) {
                                    if(!isLoadingMore) {
                                        $('.posts-list .blog-box-item').remove();
                                    }

                                    var totalPosts = response.responseJSON.found_posts;
                                    var displayedTotal = (parseInt($('#page_num').val()) * 4);
                                    var showNextPage = (displayedTotal < totalPosts);

                                    if(showNextPage) {
                                        $('.load-more').removeClass('disabled').show();
                                    } else {
                                        $('.load-more').addClass('disabled').hide();
                                    }

                                    $('body').removeClass('loading');

                                    for(var i = 0; i < response.responseJSON.items.length; i++) {
                                        var item = response.responseJSON.items[i];

                                        /*if (item.image && typeof item.image !== 'undefined') {

                                            var content = item.content.substr(0, 400);

                                            string = '<div class="row">';
                                            if (i % 2 != 0){
                                                string += '<div class="col-md-6"></div>';
                                            }
                                            string += '<div class="col-md-6"> <div class="blog-post"> <div class="thumb" style="background-image:url('+ item.image +');"></div> <div class="post"> <h2 class="post-title"><a href="' + item.permalink + '">' + item.post_title + '</a></h2> <span class="date">' + item.date + '</span> </div> <div class="excerpt"> <p>' + content + '</p> <a href="' + item.permalink + '">Read More</a> </div> <div class="shadow"></div> </div> </div>';

                                            if (i % 2 == 0){
                                                string += '<div class="col-md-6"></div>';
                                            }

                                            string += '</div>';
                                        }
                                        else {*/
										
										
                                        // item.content = $(item.content).text();
										// console.log(item.content);
										
                                        var content = item.content.substr(0, item.content.lastIndexOf(" ", 200)),
                                            string = '<div class="blog-box-item">';


                                        string += '<div class="blog-box-item"><div class="blog-item-title">' +
                                                 '<a href="' + item.permalink + '">' + item.post_title + '</a>' +
                                                 (item.date != '' ? '<div class="date-box">' + item.date + '</div>' : '') +
                                                 '</div><div class="category-name">' +
                                                 '<span>' + item.terms + '</span></div><div class="blog-item-content">' +
                                                 '<p>'+content + '</p><a href="' + item.permalink + '" class="more">READ MORE</a></div></div>';
                                        /*}*/

                                        $('.posts-list').append(string);
                                    }

                                } else {
                                    $('.posts-list .blog-box-item').not('.load-more').remove();
                                    $('.posts-list').append('<div class="blog-box-item empty-search"><h3>No articles have been found. Please try a different search keywords.</h3></div>');
                                    $('.load-more').hide();
                                }
                            }
                        }
                    });
                }

                // JavaScript to be fired on the about us page
            }
        }

    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = funcname === undefined ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.
